import React from "react";
import { YStack } from "tamagui";
import { Sheet, SheetDragHandle, SheetScrollView } from "../ui/Sheet";
import { GlobalSearchPanel } from "./GlobalSearchPanel";

type GlobalSearchOverlayProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function GlobalSearchOverlayMobile({
  open,
  onOpenChange,
}: GlobalSearchOverlayProps) {
  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange} snapPoints={[92, 55]}>
      <YStack f={1} pb="$1" pt="$1">
        <SheetDragHandle />
        <YStack f={1}>
          {open ? (
            <GlobalSearchPanel
              open
              onClose={handleClose}
              showInlineCloseButton={false}
              renderScrollComponent={(props) => <SheetScrollView {...props} />}
            />
          ) : null}
        </YStack>
      </YStack>
    </Sheet>
  );
}
